import { render, staticRenderFns } from "./WaveHeader.vue?vue&type=template&id=34199b23&"
import script from "./WaveHeader.vue?vue&type=script&lang=js&"
export * from "./WaveHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports